/**
 * Privacy Notice data — GDPR / data-protection notice.
 *
 * HOW TO UPDATE:
 *   Edit `privacyData` below for contact details that appear in the notice.
 *   To add a new language, create `src/privacy/<lang>.ts` exporting a
 *   `get<Lang>PrivacyMarkdown(data: PrivacyData): string` function, then add
 *   a case to `getPrivacyContent` below.
 *
 * FIELDS:
 *   lastUpdated      — ISO date string shown as "Last updated: …" at the top
 *   publicationName  — Name of the publication (data controller)
 *   responsiblePerson — Natural person responsible / data controller contact
 *   email            — Contact e-mail address (used as mailto: href)
 *   address          — Multi-line postal address; each entry becomes its own line
 *   country          — Country appended after the postal address lines
 */

import { impressumData } from '../impressum/index'
import { getEnPrivacyMarkdown } from './en'

export interface PrivacyData {
  lastUpdated: string
  publicationName: string
  responsiblePerson: string
  email: string
  address: string[]
  country: string
}

export const privacyData: PrivacyData = {
  lastUpdated: '2026-04-19',
  publicationName: impressumData.publicationName,
  responsiblePerson: impressumData.responsiblePerson,
  email: impressumData.email,
  address: impressumData.address,
  country: 'Germany',
}

/**
 * Returns the Privacy Notice as a GFM Markdown string for the given
 * interface language code.  Falls back to English for unsupported languages.
 *
 * To add a new language, import its function and add a `case` below.
 */
export function getPrivacyContent(lang: string): string {
  switch (lang) {
    default:
      return getEnPrivacyMarkdown(privacyData)
  }
}
